import { RootState } from "../../rootState";

export const selectedFeaturesSelector = (state: RootState) => state.selectedFeatures?.features;
